export const to = {
  msg:
    {
      username: 'Hingoa ngāueʻaki',
      password: 'Lea Fakapulipuli',
      login: 'Hu ki he Peesi',
      changeLanguage: '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      submit_button_text: 'Fakahu',
      enter: 'Fakahū',
      en: 'English',
      ms: 'Bahasa Melayu',
      id: 'Bahasa Indonesia',
      zh: 'Chinese',
      to: 'Lea Faka-Tonga',
      sm: 'Samoan',
      copyright: 'Fakaivia ʻe he Kautaha fakamāmāni lahi ko e  Global Psytech',
      new_password: 'Lea Fakapulipuli Foʻou',
      confirm_new_password: 'Fakapapauʻi Ho Lea Fakapulipuli Foʻou',
      forgot_password_header: 'NGALO ʻA E LEA FAKAPULIPULI',
      basic_info: 'Basic Information',
      password_set: 'Set Password',
      sign_up: 'Fokotuʻu e ʻAkauni',
      product_info: 'Koloa ne ke kole ke ke ngaue ki ai',
      continue: 'Hoko atu',
      back: 'Foki Ki Mui',
      cancel_reset: 'Kaniseli',
      forgot_password: 'Ngalo ʻae Lea Fakapulipuli?',
      sign_up_message: 'he Peesi ‘Initaneti koia',
      reset_success: 'Successfully reset your password. Please login using the new password.',
      dpa_heading: 'Aleapau Maluʻi e Ngaahi Fakamatala Faka- Foʻituitui',
      dpa_body1: 'Ko au GFI ʻoku ou fakapapauʻi heni ʻoku ou loto ke tauhi ‘a e malu ‘o e ngaahi fakamatala ʻoku tuku atu ko ʻeni ʻo fakatatau ki he Lao ki hono Maluʻi ‘o e Ngaahi Fakamatala. Fakatatau ki he ngaahi tuʻutuʻuni fekauʻaki mo hono tauhi malu ‘o e ngaahi fakamatalá, ʻoku mau fakapapauʻi ko e ngaahi fakamatala kotoa pē ‘oku tānaki ‘i he ngaahi sivi ko ʻení, ‘e tuku atu pē ia ki he tokotaha ‘oku ʻaʻana ʻa e siví, ʻa ia ʻoku mau tokangaʻi pē ko haʻa ne fakafofonga kuo ne ‘osi fakamafaiʻi kene fakafofongaʻi ia.',
      dpa_body2: 'Koe kotoa ʻo e ngaahi fakamatala ‘e tauhi ia pea toki tuku atu ʻi he founga malu mo pau, ʻo tatau ai pē pe ʻoku nofo ʻa e tokotaha ʻaʻana e sivi ʻi Tonga pe ʻi tuʻapuleʻanga.',
      dpa_body3: 'Kapau ʻe to e ‘i ai ha fetuʻutaki felaveʻi mo hono ngāueʻaki ‘o e ngaahi fakamatala, ‘e fakahoko pē ia ʻo fakatatau ki he ngaahi tuʻutuʻuni mo e ngaahi makatuʻunga ‘e tuku mai ʻe he tokotaha ʻaʻana e sivi mo ʻene ngaahi fakangatangata.',
      close: 'TĀPUNI',
      reset_button: 'Fakahu',
      successfully_register: 'Kuo ke lava lelei ‘o lesisita. Kataki fakahu mai ho hingoa ngaue’aki kuo lesisita pea mo ho fika loka.',
      cloned_user: '‘Oku kei sai pe ho sivi moe ola ho sivi GFI, ‘aia ‘oku ‘ikai fiema’u ke ke toe sivi GFI fo’ou.',
      password_changed: 'Kataki kamata ʻaki ho fakahu mai ho lea fakapulipuli foʻou.',
      loading_text: 'Kei fakahoko e ngāue...',
      month_label: 'Ngaahi mahina',
      create_registration: 'Faʻu ho hingoa lesisitá mo e hingoa ngāué.'
    },
  error: {
    full_name_required: 'Kataki ‘o tohi’i mai ho hingoa kakato hange koia ‘oku ha ‘i ho ID fakafonua.',
    full_name_min: 'Ko e hingoa kakato kuopau ke laka hake ʻi ngaahi fakaʻilonga ʻe 5.',
    full_name_max: 'Ko e hingoa kakato ʻe ʻikai laka hake he foʻi fakaʻilonga ʻe 80.',
    full_name_regex: 'Koe ngaahi fakaʻilonga pe ʻoku tali ke ngaueʻaki ko e ngaahi lea he ʻalifalepeti, ngaahi sipeisi, pea mo e ngaahi fakaʻilonga: @ ʻ – pea mo e / .',

    id_num_required: 'Kataki fakahu mai ho fika ID.',
    id_num_max: 'Koe ID ‘e ‘ikai loloa ange ia ha ngaahi lea pe ngaahi faka’ilonga ‘e 20.',
    id_num_regex: 'Koe ngaahi lea pe ʻoku tali ke ngaueʻaki ko e ngaahi lea he alifalepeti pea mo e ngaahi fika.',

    business_reg_required: 'Kataki ‘o tohi’i mai ‘ae lesisita ho pisinisi/ fika laiseni ho pisinisi.',
    business_reg_max: 'Ko e lesisita e pisinisi/fika laiseni  ‘e ‘ikai loloa ange ia ‘I he ngaahi lea pe faka’ilonga ‘e 20.',
    business_reg_min: 'Ko e fika lesisita ʻo e pisinisi kuo pau ke ʻoua ʻe siʻi hifo he foʻi fakaʻilonga ʻe 5.',
    business_reg_regex: 'Koe ngaahi lea pe ʻoku tali ke ngaueʻaki ko e ngaahi lea he alifalepeti pea mo e ngaahi fika.',

    company_name_required: 'Kataki ‘o fakahu mai ‘a e hiongoa ho kautaha.',
    company_name_min: 'Kuopau ke ʻikai toe siʻisiʻi hifo ʻa e hingoa ʻo e kautaha ʻi he ngaahi fakaʻilonga ʻe 5.',
    company_name_max: '‘E ‘ikai ke loloa ange ‘a e hingoa ‘o e kautaha ‘I he ngaahi lea pe ngaahi faka’ilonga ‘e 80.',
    company_name_regex: 'Koe ngaahi fakaʻilonga pe ʻoku tali ke ngaueʻaki ko e ngaahi lea he ʻalifalepeti, ngaahi sipeisi, pea mo e fika pea mo e  ngaahi faka’ilonga: , - & () pea mo e ‘ .',

    business_category_required: 'Select business category.',
    product_applied_required: 'Kataki ‘o fili mai ‘a e koloa ‘oku ke fili ke ke ngaue ki ai ‘I ho no.',
    commencement_date_required: 'Please enter your company’s business commencement date.',
    facility_required: 'Please select the facilities you are applying.',
    facilities_required: 'Please select the facilities you are applying.',

    amount_applied_required: 'Kataki ‘o fakahu mai ‘a e lahi ‘o e pa’anga ‘oku ke kole ke ke no.',
    amount_applied_maxvalue: 'ʻE ʻikai laka hake ʻa e paʻange oku kole ʻi he paʻanga ʻe {0} {2}.',
    amount_applied_minvalue: 'Kuo pau ke ʻoua ʻe siʻi ange ʻa e paʻange ʻoku kole mei he paʻanga ʻe {1}.',

    tenure_required: 'Kataki ‘o fakahu mai ‘a e taimi ‘oku ke totongi fakafoki mai ai.',
    tenure_maxvalue: 'Koe loloa taha ‘o e taimi ke totongi ai ‘e ikai laka hake ‘I he mahina ‘e {1}.',
    tenure_minvalue: 'Kuopau ke ‘oua ‘e toe si’i ange ‘i he mahina ‘e {0} ‘a e vaha’ataimi ke fakapa’anga ai, pe ko e loloa ‘o e no.',

    officerinchargeid_required: 'Please enter the ID number of Loan Officer you are dealing with.',
    officerinchargeid_invalid: 'Invalid Loan Officer ID. Please enter the correct Loan Officer ID.',
    officerinchargeid_regex: 'Koe ngaahi lea pe ‘oku tali ke ngaue’aki ko e ngaahi lea he alifalepeti, ngaahi fika pea mo e  ngaahi faka’ilonga: ! # - pea moe @',
    officerinchargeid_min: 'The ID must be at least 6 characters long.',
    officerinchargeid_max: 'The ID number cannot be longer than 15 characters.',

    username_required: 'Kataki ʻo fakahu ha hingoa ngaueʻaki.',
    username_min: 'Kuo pau ke ʻoua ʻe siʻi ange ho hingoa ngaueʻaki ʻi he ngaahi lea pe fakaʻilonga ʻe 6.',
    username_max: 'ʻE ʻikai ke loloa ange ʻa e ngaahi fakaʻilonga ho hingoa ngaueʻaki ʻi he 15.',
    username_regex: 'Koe ngaahi lea pe ‘oku tali ke ngaue’aki ko e ngaahi lea he alifalepeti, ngaahi fika pea mo e  ngaahi faka’ilonga: ! # - pea moe @',
    username_duplicate: 'Kuo ʻosi ngaueʻaki ʻa e hingoa ngaueʻaki ko eni. Kataki fahahu ha hingoa ngaueʻaki kehe.',

    password_required: 'Kataki ʻo fakahu mai ha Lea Fakapulipuli.',
    password_min: 'Ko hoʻo lea fakapulipuli foʻou ʻe ʻikai siʻi hifo ia ʻi he ngaahi lea pe fakaʻilonga ʻe 6.',
    password_max: 'ʻE ikai loloa ange ho lea fakapulipuli ha ngaahi fakaʻilonga ʻe 15.',
    password_regex: 'Koe ngaahi fakaʻilonga ʻoku tali ke ngaueʻaki ko e ngaahi lea he alifalepeti, ngaahi fika pea mo e ngaahi fakaʻilonga: ! # - pea moe @ .',
    confirm_password_regex: 'Koe ngaahi fakaʻilonga ʻoku tali ke ngaueʻaki ko e ngaahi lea he alifalepeti, ngaahi fika pea mo e ngaahi fakaʻilonga: ! # - pea moe @ .',
    new_password_regex: 'Koe ngaahi fakaʻilonga ʻoku tali ke ngaueʻaki ko e ngaahi lea he alifalepeti, ngaahi fika pea mo e ngaahi fakaʻilonga: ! # - pea moe @ .',

    confirm_password_required: 'Kataki ʻo toe fakahu mai ho lea fakapulipuli ke fakapapauʻi.',
    confirm_password_confirmed: 'ʻOku ʻikai ke tatau ho lea fakapulipuli ʻi hono fakapapauʻi.',
    confirm_password_min: 'Ko hoʻo lea fakapulipuli foʻou ʻe ʻikai siʻi hifo ia ʻi he ngaahi lea pe fakaʻilonga ʻe 6.',
    confirm_password_max: 'ʻE ikai loloa ange ho lea fakapulipuli ha ngaahi fakaʻilonga ʻe 15.',

    registrationtoken_required: 'Kataki ‘o fakahu mai ‘a e fika pe kouti fakapapau’i na’e ‘oatu kiate koe.',
    registrationtoken_min: 'ʻOku fiemaʻu ho fika fakapapuʻi ke ngaahi fakaʻilonga ʻe 6.',
    registrationtoken_max: 'ʻOku fiemaʻu ho fika fakapapuʻi ke ngaahi fakaʻilonga ʻe 6.',
    registrationtoken_duplicate: 'Fika fakapapau’i hala. Kataki fakahu mai ‘a e fika fakapapau’i totonu.',
    registrationtoken_regex: 'Koe ngaahi lea pe ʻoku tali ke ngaueʻaki ko e ngaahi lea he alifalepeti pea mo e ngaahi fika.',

    confirm_password_placeholder: 'Kataki ‘o to e fakahu ho fika loka.',

    error: 'ʻOku hala hoʻo Hingoa Ngaueʻaki pe Lea Fakapulipuli.',
    registration_error: 'Kataki na’e ‘iai e fehalaaki. Kataki toe fakafo’ou ‘a e peesi ko eni pea ke toe feinga fo’ou.',
    new_password_required: 'Kataki ʻo fakahu mai ho lea fakapulipuli.',
    confirm_new_password_required: 'Kataki fakahu mai ho hingoa ngaue’aki fo’ou.',
    invalid_credentials: 'ʻOku hala hoʻo Hingoa Ngaueʻaki pe Lea Fakapulipuli.',

    consent_required: 'Kimu’a ke ke lesisita, kuopau ke ke lau ‘a e Aleapau Malu’i e Ngaahi Fakamatala Faka- Fo’ituitui pea ke tali ‘aki ho’o tiki pe faka’ilonga’i ‘a e ki’i puha ‘oku ha atu ai',

    reset_invalid: 'We are unable to find your account by the details provided.',
    new_password_min: 'Ko hoʻo lea fakapulipuli foʻou ʻe ʻikai siʻi hifo ia ʻi he ngaahi lea pe fakaʻilonga ʻe 6.',
    new_password_max: 'ʻE ikai loloa ange ho lea fakapulipuli ha ngaahi fakaʻilonga ʻe 15.',
    confirm_new_password_min: 'Ko hoʻo lea fakapulipuli foʻou ʻe ʻikai siʻi hifo ia ʻi he ngaahi lea pe fakaʻilonga ʻe 6.',
    confirm_new_password_max: 'ʻE ikai loloa ange ho lea fakapulipuli ha ngaahi fakaʻilonga ʻe 15.',
    confirm_new_password_confirmed: '‘Oku ‘ikai ke tatau ho fika loka pea mo e fakapapau’i.',
    register_username_details_does_not_match: 'ʻOku ʻikai tatau ho fika ID pea mo e lekooti lesisita.',
    register_username_not_found: 'Ngalo ho hingoa ngaue’aki? Kataki fetu’utaki ki he Tafa’aki Tokoni.',
    data_tempered: 'Unable to reset your password. Please try again later.',
    branch_required: 'Kataki ‘o fakahu mai ‘a e Va’a.',
    drop_down_not_available: '‘Ikai ha fakamatala',
    repeating_user: 'Kataki ‘oku ‘ikai ke lava ke fai ha ngaue ki ho lesisita.',

    id_type_required: 'Kataki fili e fa’ahinga ID te ke ngaue’aki.'
  },
  registration: {
    full_name: 'Hingoa kakato( hange koia ‘oku ha ‘i ho ID)',
    id_num: 'Ho fika ID (ID)',
    business_reg: 'Lesisita Pisinisi/Fika laiseni ho pisinisi',
    company_name: 'Hingoa ‘o e Kautaha',
    product_applied: 'Koloa ne ke kole ke ke ngaue ki ai',
    commencement_date: 'Business Commencement Date',
    facilities: 'Facilities Applied',
    amount_applied: 'Lahi e pa’anga ‘oku fiema’u (Pa’anga)',
    tenure: 'Vaha’ataimi ke fakapa’anga’i ai pe ko e loloa ‘o e no. (‘i he mahina)',
    business_category: 'Business Category',
    confirm_password: 'Fakapapauʻi ho lea fakapulipuli',
    verification_code: 'Fika pe Kouti fakapapau’i',
    consent1: 'Kuo u ʻosi lau mo mahino kiate au ʻa e',
    consent2: 'Aleapau ʻo e Maluʻi ʻo e Ngaahi Fakamatala Fakafoʻituitui',
    consent3: 'felaveʻi mo au pea mo hono ngaueʻaki fakatatau ki he Aleapau koia.',
    cancel: 'Kaniseli',
    register: 'Lesisita',
    branch: 'Va’a',
    officer: 'Loan Officer ID No.',
    id_type: 'Fa’ahinga ID'
  }
}
